import Btn from './shared/Btn';

/**
 * Sticky bottom action bar in Expert mode. Always rendered alongside
 * ValidationPanel. Status dot reflects validation state.
 *
 * @param {{
 *   editable: boolean,
 *   errorCount: number,
 *   warningCount: number,
 *   validating: boolean,
 *   onValidate: () => void,
 *   onPreview: () => void,
 *   onSubmit: () => void,
 *   onSave?: () => void,
 *   hasDirty?: boolean,
 *   saveState?: string,
 * }} props
 */
export default function ExpertActionBar({
  editable, errorCount, warningCount, validating, onValidate, onPreview, onSubmit,
  onSave, hasDirty, saveState,
}) {
  const dotColor = errorCount > 0 ? 'var(--ab-denied)' :
    warningCount > 0 ? 'var(--ab-pending)' :
    'var(--ab-approved)';
  const status = errorCount > 0 ? `${errorCount} issue${errorCount > 1 ? 's' : ''}` :
    warningCount > 0 ? `${warningCount} warning${warningCount > 1 ? 's' : ''}` :
    editable ? 'Ready' : 'Submitted';

  return (
    <div style={{
      position: 'sticky', bottom: 0, zIndex: 10,
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '12px 24px',
      background: 'var(--ab-bg)',
      borderTop: '1px solid var(--ab-border-hair)',
      boxShadow: 'var(--ab-shadow-md)',
    }}>
      <span style={{
        width: 10, height: 10, borderRadius: '50%', background: dotColor,
      }} />
      <span style={{ fontSize: 13, fontWeight: 'var(--ab-weight-semi)' }}>{status}</span>
      <div style={{ flex: 1 }} />
      {editable && onSave && (
        <Btn
          kind="secondary"
          icon="save"
          onClick={onSave}
          disabled={!hasDirty || saveState === 'saving'}
        >
          {saveState === 'saving' ? 'Saving…' : 'Save'}
        </Btn>
      )}
      {editable && (
        <Btn kind="secondary" icon="check-circle" onClick={onValidate} disabled={validating}>
          {validating ? 'Validating…' : 'Validate'}
        </Btn>
      )}
      <Btn kind="secondary" icon="eye" onClick={onPreview}>Preview CMS-1500</Btn>
      {editable && (
        <Btn kind="primary" icon="send" onClick={onSubmit} aria-disabled={errorCount > 0}>
          Submit
        </Btn>
      )}
    </div>
  );
}
